/** Action responsável por tratar quando o valor de uma parcela é alterado */
function parcelaChange(object) {
  return {
    type: "PARCELA_CHANGE",
    parcelas: object
  };
}

export default parcelaChange;



// WEBPACK FOOTER //
// ./src/store/actions/acordo/parcela/change.js